import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import * as S from './styles';
import Helper from 'components/Helper';
import Header from 'components/Layout/Header';
import RenderMenuContent from 'components/RenderMenuContent';
import SideBar from 'components/SideBar';
import Spin from 'components/Spin';
import { useMenuSelection } from 'global/MenuSelectionContext';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useUser } from 'global/UserContext';
import { useSideBar } from 'hooks/useSideBar';
import ThirdLevelLayout from 'pages/ThirdLevelLayout';
import { useIsDesktop } from 'utils/mediaQueries';

interface ILayout {
  children: React.ReactNode | React.ReactNode[];
}

const Layout = ({ children }: ILayout) => {
  const {
    currentLevel,
    firstLevelMenu,
    secondLevelMenu,
    thirdLevelMenu,
    activeModulePath,
    activeDocumentId,
  } = useMenuSelection();

  const { open } = useSideBar();
  const { isLoading } = useUser();
  const isDesktop = useIsDesktop();
  const [showUserCard, setShowUserCard] = useState(false);
  const isVisibleCard = activeDocumentId === 'bhnrs7gefue5v5ntzqg3ls74';

  const theme = useThemeContext();
  const location = useLocation();

  // Verifica se o tema está carregado corretamente
  const [themeError, setThemeError] = useState(false);
  useEffect(() => {
    if (!isLoading && !theme) {
      setThemeError(true);
    }
  }, [theme, isLoading]);

  // Log para debug do layout
  useEffect(() => {
    console.log('[Layout] Estado atual:', {
      currentLevel,
      firstLevelMenu: firstLevelMenu?.label,
      secondLevelMenu: secondLevelMenu?.label,
      thirdLevelMenu: thirdLevelMenu?.label,
      activeDocumentId,
      path: location.pathname,
    });
  }, [
    currentLevel,
    firstLevelMenu,
    secondLevelMenu,
    thirdLevelMenu,
    activeDocumentId,
    location.pathname,
  ]);

  if (themeError) {
    return (
      <S.Main>
        <S.Container>
          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <h2>Erro ao carregar o tema</h2>
            <p>O tema não foi carregado corretamente. Tente novamente.</p>
            <button onClick={() => window.location.reload()}>Recarregar página</button>
          </div>
        </S.Container>
      </S.Main>
    );
  }

  return (
    <S.Main>
      <S.Container>
        <>
          {isDesktop && (
            <>
              <SideBar />
              <Header />
              <>
                {isLoading ? (
                  <S.LoadingContainer>
                    <Spin centerHorizontally centerVertically />
                  </S.LoadingContainer>
                ) : (
                  <>
                    {currentLevel === 'first' && (
                      <S.Wrapper open={true} isFirstLevel={true}>
                        <S.Content>
                          <RenderMenuContent menu={firstLevelMenu}>{children}</RenderMenuContent>
                        </S.Content>
                      </S.Wrapper>
                    )}
                    {currentLevel === 'second' && (
                      <S.Wrapper open={true} isFirstLevel={false}>
                        <S.Content>
                          <RenderMenuContent menu={secondLevelMenu}>{children}</RenderMenuContent>
                        </S.Content>
                      </S.Wrapper>
                    )}
                    {currentLevel === 'third' && (
                      <S.Wrapper open={true} isFirstLevel={false}>
                        <S.Content>
                          <ThirdLevelLayout>{children}</ThirdLevelLayout>
                        </S.Content>
                      </S.Wrapper>
                    )}
                    {!currentLevel && (
                      <S.Wrapper open={true} isFirstLevel={false}>
                        <S.Content>{children}</S.Content>
                      </S.Wrapper>
                    )}
                  </>
                )}
                <Helper />
              </>
            </>
          )}
        </>
      </S.Container>
    </S.Main>
  );
};

export default Layout;
